module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_5010.41506357.png";